/** 自动完成规则 — 触发方式 */
export type AutoCompleteTriggerType = 'api' | 'mq';

/** 规则最近一次非测试执行（列表展示） */
export type AutoCompleteRuleLastRunStatus = 'success' | 'failed' | 'none';

export interface AutoCompleteRuleLastRun {
  status: AutoCompleteRuleLastRunStatus;
  /** 最近一次 normal 执行时间 */
  time?: string;
}

/** 节点自动完成规则（完整模型，供后续接口对齐） */
export interface NodeAutoCompleteRule {
  id: string;
  name: string;
  enabled: boolean;
  triggerType: AutoCompleteTriggerType;
  /** 接口触发 Key */
  triggerKey?: string;
  /** MQ VHost（Apollo 配置） */
  mqVhost?: string;
  /** MQ 队列名称（Apollo 配置） */
  mqQueue?: string;
  prepareScript: string;
  prepareTimeoutSec: number;
  prepareRetryCount: number;
  decisionScript: string;
  decisionTimeoutSec: number;
  decisionRetryCount: number;
  /** 当前内容版本号 */
  version?: number;
  linkedNodeCount?: number;
  /** 关联里程碑节点名称列表（悬停展示） */
  linkedNodeNames?: string[];
  lastRun?: AutoCompleteRuleLastRun;
  createTime?: string;
  updateTime?: string;
}

/** 规则编辑表单 */
export type NodeAutoCompleteRuleForm = Omit<NodeAutoCompleteRule, 'id' | 'linkedNodeCount' | 'lastRun'> & {
  id?: string;
};

export const DEFAULT_PREPARE_SCRIPT = `function execute(context, services) {
  const triggerPayload = context.triggerPayload;
  const nodeContext = context.nodeContext;
  // 在此编写数据准备逻辑，可使用 services.http、dbQuery 等
  return null;
}`;

export const DEFAULT_DECISION_SCRIPT = `function execute(context, services) {
  const triggerPayload = context.triggerPayload;
  const nodeContext = context.nodeContext;
  const preparedData = context.preparedData;

  if (preparedData && /* 在此补充完成条件 */ false) {
    return { action: 'complete_node' };
  }

  return { action: 'noop' };
}`;

export function createEmptyAutoCompleteRuleForm(): NodeAutoCompleteRuleForm {
  return {
    name: '',
    enabled: true,
    triggerType: 'api',
    triggerKey: '',
    mqVhost: undefined,
    mqQueue: undefined,
    prepareScript: DEFAULT_PREPARE_SCRIPT,
    prepareTimeoutSec: 100,
    prepareRetryCount: 3,
    decisionScript: DEFAULT_DECISION_SCRIPT,
    decisionTimeoutSec: 100,
    decisionRetryCount: 3,
  };
}
